import React from 'react';
import { Modal, Button, Alert } from 'react-bootstrap';
import { useAlertModal } from '../AlertModalContext';

const AlertModalComponent = () => {
  const { modalState, hideAlertModal } = useAlertModal();

  if (!modalState.show) {
    return null;
  }

  return (
    <Modal show={modalState.show} onHide={hideAlertModal} centered>
      <Modal.Header closeButton>
        <Modal.Title>{modalState.title || 'Alerta'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* Usar o componente Alert do react-bootstrap para consistência visual se desejado */}
        <Alert variant={modalState.variant} className="mb-0">
          {typeof modalState.message === 'string' ? modalState.message : JSON.stringify(modalState.message)}
        </Alert>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={hideAlertModal}>
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AlertModalComponent;